import React from 'react';
import { ScrollView } from 'react-native';
import BreadCrumbsContainer from 'src/components/10-atoms/BreadCrumbs/Container';
import Button from 'src/components/10-atoms/button/Button';
import { FileType } from 'src/components/10-atoms/file-picker/types';
import Field from 'src/components/10-atoms/form/Field';
import { getFieldError } from 'src/components/10-atoms/form/hooks/useFieldState/utils';
import DateInput from 'src/components/10-atoms/form/inputs/DateInput';
import FileInput from 'src/components/10-atoms/form/inputs/FileInput';
import TextInput from 'src/components/10-atoms/form/inputs/TextInput';
import FeatherIcon from 'src/components/10-atoms/icons/FeatherIcon';
import Column from 'src/components/10-atoms/layout/Column';
import OverlayLayout from 'src/components/10-atoms/overlays/OverlayLayout';
import BottomDrawerLayout from 'src/components/20-helper-views/bottom-drawer/BottomDrawerLayout';
import { bottomDrawerHelperActions } from 'src/components/20-helper-views/bottom-drawer/useBottomDrawer';
import useTheme from 'src/customizations/themes/hooks/useTheme';
import createThemedStyle from 'src/customizations/themes/utils/createThemedStyles';
import useEffectWithCtx from 'src/hooks/useEffectUtils/useEffectWithCtx';
import getBreadCrumbs from 'src/modules/exam-preparation/components/EPBreadCrumbs/getBreadCrumbs';
import ChangesSentForReviewDrawer from 'src/modules/exam-preparation/components/contributions/ChangesSentForReviewDrawer';
import QPImagesGuidelines from './QPImagesGuidelines';
import useData from './useData';
const TWENTY_YEARS = 20 * 365 * 24 * 60 * 60 * 1000;
const QPFormOverlay = ({ subjectID, qpID, onClose, onComplete, }) => {
    const [{ theme }] = useTheme(stylesGenerator);
    const [state, actions] = useData({ subjectID, qpID });
    useEffectWithCtx(ctx => {
        if (ctx.state.contributionResponse) {
            ctx.actions.contributionResponseHandler.handle(ctx.state.contributionResponse).then(ctx.onComplete).catch((error) => {
                console.log('Failed to save QP:', error);
            });
        }
    }, { onComplete, actions, state }, [state.contributionResponse]);
    return (React.createElement(Column, { flex: true },
        React.createElement(OverlayLayout.FormHeader, { title: state.isEditMode ? 'Edit Question Paper' : 'Upload Question Paper', onClose: onClose }),
        React.createElement(Column, { flex: true },
            React.createElement(ScrollView, null,
                React.createElement(Column, { spacing: theme.spacing.standard.md, ph: theme.spacing.page, pv: theme.spacing.standard.sm },
                    React.createElement(Field, { label: "Subject" },
                        React.createElement(BreadCrumbsContainer, { loading: state.subjectDetailsQuery.loading, crumbs: getBreadCrumbs({}, {
                                ...state.subjectDetailsQuery.data?.ep_subjectDetails
                                    .ancestorsDetails,
                                subject: state.subjectDetailsQuery.data?.ep_subjectDetails,
                            }), visibleCount: 5 })),
                    React.createElement(Field, { label: "Date", error: getFieldError(state.form.fields.date.errors) },
                        React.createElement(DateInput, { placeholder: "Examination date", maxValue: new Date(), minValue: new Date(Date.now() - TWENTY_YEARS), value: state.form.fields.date.value, onChange: newValue => {
                                actions.form.fields.date.setValue(newValue);
                            } })),
                    state.isEditMode && (React.createElement(Field, { label: "Label", error: getFieldError(state.form.fields.label.errors) },
                        React.createElement(TextInput, { placeholder: "e.g. Dec 2024", value: state.form.fields.label.value, onChange: actions.form.fields.label.setValue }))),
                    React.createElement(Field, { label: "Question Paper Image(s)", error: getFieldError(state.form.fields.qpImages.errors) },
                        React.createElement(FileInput, { allowedTypes: [FileType.IMAGES, FileType.PDF], value: state.form.fields.qpImages.value, onChange: actions.form.fields.qpImages.setValue, maxCount: 20 }),
                        React.createElement(QPImagesGuidelines, null))),
                React.createElement(Column, { style: { height: 400 } }))),
        React.createElement(BottomDrawerLayout.Actions, { btw: 1, spacing: theme.spacing.standard.md, pv: theme.spacing.standard.sm },
            React.createElement(Button, { disabled: state.submitting, flex: true, variant: "outline", onPress: () => {
                    if (state.isEditMode) {
                        onClose();
                        return;
                    }
                    bottomDrawerHelperActions.show({
                        component: (React.createElement(ChangesSentForReviewDrawer, { title: "Question Paper uploaded successfully \uD83C\uDF89", onConfirm: bottomDrawerHelperActions.hide })),
                    });
                } }, "Cancel"),
            React.createElement(Button, { loading: state.submitting, flex: true, LeftIcon: props => React.createElement(FeatherIcon, { name: "save", ...props }), onPress: actions.handleSubmit }, "Submit"))));
};
const stylesGenerator = createThemedStyle(({}) => ({}));
export default QPFormOverlay;
